import type { Agent, Call, Service } from "../types";

export function resolveCallServiceId(
	call: Pick<Call, "agent" | "serviceId">,
	agents: Agent[],
	services: Service[],
): string | null {
	if (call.serviceId) {
		return call.serviceId;
	}

	const agentServiceId =
		agents.find((agent) => agent.name === call.agent)?.serviceId ?? null;
	if (agentServiceId) {
		return agentServiceId;
	}

	if (services.length === 1) {
		return services[0].id ?? null;
	}

	return null;
}
